import { render, staticRenderFns } from "./PhotoContribution.vue?vue&type=template&id=52353f6e"
import script from "./PhotoContribution.vue?vue&type=script&lang=js"
export * from "./PhotoContribution.vue?vue&type=script&lang=js"
import style0 from "./PhotoContribution.vue?vue&type=style&index=0&id=52353f6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports